module.exports = __webpack_public_path__ + "img/toolbox.27b57a92.png";